// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.update_account {
  padding: 2em 2em 0em 2em;
  max-width: 24em;
  height: 100vh;
  overflow-y: auto;
}

.subscription-history__sidenav, .customer-history__sidenav {
  width: 66vw;
}

.provision-history__sidenav {
  width: 90vw;
}

.subscription-history__sidenav__error {
  width: 20vw;
}

.create-cms-ticket__sidenav, .phone-capability__sidenav, .app-features__sidenav {
  width: 24em;
  padding: 2em 2em 0em 2em;
}

.vehicle-history__sidenav {
  width: 98vw;
}

.app-features__sidenav, .user-profile__sidenav, .give-goodwill__sidenav, .update-remote-user__sidenav, .app-show-flags__sidenav {
  width: 30em;
  padding: 2em 2em 0em 2em;
}

.authorize-remote__sidenav {
  padding: 8em 2em 0em 2em;
  max-width: 33em;
}

.vehicle-remotelist_sidenav {
  width: 33em;
}

.data-consent__sidenav {
  width: 36.75em;
  padding: 2em 2em 0 2em;
}

.emergency-contact__sidenav {
  width: 36.75em;
  padding: 2em 2em 0 2em;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/acm/side-nav/side-nav.component.scss"],"names":[],"mappings":"AACA;EACE,wBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;EACA,wBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;EACA,wBAAA;AACF;;AAEA;EACE,wBAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,cAAA;EACA,sBAAA;AACF;;AAEA;EACE,cAAA;EACA,sBAAA;AACF","sourcesContent":["\n.update_account {\n  padding: 2em 2em 0em 2em;\n  max-width: 24em;\n  height: 100vh;\n  overflow-y: auto;\n}\n\n.subscription-history__sidenav, .customer-history__sidenav {\n  width: 66vw;\n}\n\n.provision-history__sidenav {\n  width:90vw;\n}\n.subscription-history__sidenav__error {\n  width: 20vw;\n}\n\n.create-cms-ticket__sidenav, .phone-capability__sidenav, .app-features__sidenav {\n  width: 24em;\n  padding: 2em 2em 0em 2em;\n}\n\n.vehicle-history__sidenav {\n  width: 98vw;\n}\n\n.app-features__sidenav, .user-profile__sidenav, .give-goodwill__sidenav, .update-remote-user__sidenav, .app-show-flags__sidenav {\n  width: 30em;\n  padding: 2em 2em 0em 2em;\n}\n\n.authorize-remote__sidenav {\n  padding: 8em 2em 0em 2em;\n  max-width: 33em;\n}\n\n.vehicle-remotelist_sidenav {\n  width: 33em;\n}\n\n.data-consent__sidenav {\n  width: 36.75em;\n  padding: 2em 2em 0 2em;\n}\n\n.emergency-contact__sidenav {\n  width: 36.75em;\n  padding: 2em 2em 0 2em;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
